module.exports = __webpack_public_path__ + "2ab001abe1ea0cd2bf302eb421df8803.woff2";